export const BYTES_IN_KILOBYTES = 1024;
export const BYTES_IN_MEGABYTE = BYTES_IN_KILOBYTES ** 2;
export const FILE_SIZE_UNITS = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
